module.exports = __webpack_public_path__ + "img/logo.21e9f7c4.png";